/// <reference types="@angular/localize" />

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { registerLocaleData } from '@angular/common';
import localeHe from '@angular/common/locales/he';
import localeAr from '@angular/common/locales/ar';
import localeEn from '@angular/common/locales/en';
// import '@here/maps-api-for-javascript/bin/mapsjs.bundle.harp'

registerLocaleData(localeHe, 'he');
registerLocaleData(localeAr, 'ar');
registerLocaleData(localeEn, 'en');

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
